import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, Drawer, SvgIcon, Typography, useMediaQuery } from '@mui/material';
import {QRCodeSVG} from 'qrcode.react';
// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';
import { useNavigate } from 'react-router-dom';
import { Download } from '@mui/icons-material';
import React from 'react';
import { showError } from '../../../utils/common';

// ==============================|| SIDEBAR DRAWER ||============================== //
function CurvedArrowIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M3 15c0-.55.45-1 1-1h6c.55 0 1-.45 1-1V7.41l1.88 1.88a.996.996 0 101.41-1.41L10.71 4.29a1.003 1.003 0 00-1.42 0L6.71 6.88a.996.996 0 101.41 1.41L9 7.41V13H4c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1V5.41l2.29 2.29a.996.996 0 101.41-1.41L12.71 2.29a.996.996 0 00-1.42 0L6.71 6.88a.996.996 0 101.41 1.41L9 7.41V13c0 .55-.45 1-1 1H4c-.55 0-1 .45-1 1z"
      />
    </SvgIcon>
  );
}
const openTopUpLink = () => {
  window.open("https://www.feishu.cn/invitation/page/add_contact/?token=4f3n58ac-af38-48d2-b772-313523589c7f&amp;unique_id=snU5zT16TZkNIzqE6RT3GA==", '_blank');
};
const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const navigate = useNavigate(); // 获取导航函数
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const drawer = (
    <>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
          <LogoSection />
        </Box>
      </Box>
      <BrowserView>
        <PerfectScrollbar
          component="div"
          style={{
            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
            paddingLeft: '16px',
            paddingRight: '16px'
          }}
        >
          <MenuList />
          <MenuCard />
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* 倒计时放在二维码上方 */}
            <Typography variant="h5" sx={{ marginBottom: 2 }}>
              飞书扫描二维码，添加我为联系人
            </Typography>
            <QRCodeSVG value="https://www.feishu.cn/invitation/page/add_contact/?token=4f3n58ac-af38-48d2-b772-313523589c7f&amp;unique_id=snU5zT16TZkNIzqE6RT3GA==" size={180} /> {/* 使用二维码组件生成二维码 */}
            <Typography variant="h4" sx={{ marginTop: 2 }}>
              有问题？            <Button variant="text" onClick={openTopUpLink}>
              点击联系
            </Button>
            </Typography>

          </Box>

        </PerfectScrollbar>
      </BrowserView>
      <MobileView>
        <Box sx={{ px: 2 }}>
          <MenuList onItemClick={drawerToggle}/>
          <MenuCard />
        </Box>
      </MobileView>
    </>
  );

  const container = window !== undefined ? () => window.document.body : undefined;

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
      <Drawer
        container={container}
        variant={matchUpMd ? 'persistent' : 'temporary'}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            background: theme.palette.background.default,
            color: theme.palette.text.primary,
            borderRight: 'none',
            [theme.breakpoints.up('md')]: {
              top: '88px'
            }
          }
        }}
        ModalProps={{ keepMounted: true }}
        color="inherit"
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object
};

export default Sidebar;
